import { render, staticRenderFns } from "./InboundDetailsPopup.vue?vue&type=template&id=a995987a&scoped=true&"
import script from "./InboundDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./InboundDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a995987a",
  null
  
)

export default component.exports